export class YtPlayer {
    constructor() {
        this.players = {};
        this.ready = false;
        this.pendingId = null;
        this.pendingPlay = null;
    }

    setYtPlayerIns(container) {
        const videoId = container.dataset.ytContainer;
        const containerId = container.id;
        this.players[containerId] = {};
        this.players[containerId].videoId = videoId;

        this.players[containerId].instance = new YT.Player(containerId, {
            height: '360',
            width: '640',
            videoId: videoId,
            events: {
                onReady: () => {
                    this.ready = true;
                    if (this.pendingPlay && this.pendingId === containerId) {
                        this.pendingPlay();
                        this.pendingPlay = null;
                    }
                },
                onStateChange: this.onStateChange.bind(this),
                onError: this.onError,
            },
        });
    }

    onStateChange({ target }) {
        //同時再生させないため再生中の他のプレーヤーがあれば止める
        Object.keys(this.players).forEach((containerId) => {
            const player = this.players[containerId].instance;
            if (player === target) return;
            const state = player.getPlayerState();
            if (state === YT.PlayerState.PLAYING) {
                player.stopVideo();
            }
        });
    }

    play(containerId) {
        if (!this.ready) {
            this.pendingId = containerId;
            this.pendingPlay = () => {
                this.players[containerId].instance.playVideo();
            };
            return;
        }
        this.players[containerId].instance.playVideo();
    }

    stop(containerId) {
        if (!this.ready) {
            this.pendingId = null;
            this.pendingPlay = null;
            return;
        }
        this.players[containerId].instance.stopVideo();
    }

    onError(e) {
        console.log(e);
    }
}
